export type Permission =
  | 'manage_facilities'
  | 'manage_contractors'
  | 'view_schedules'
  | 'create_shifts'
  | 'manage_shifts'
  | 'view_timesheets'
  | 'view_invoices'
  | 'view_reports'
  | 'manage_schedules'
  | 'approve_shifts'
  | 'cancel_shifts'
  | 'view_contractors'
  | 'rate_contractors'
  | 'view_contractor_documents'
  | 'approve_timesheets'
  | 'edit_timesheets'
  | 'manage_invoices'
  | 'view_billing_rates'
  | 'manage_billing_rates'
  | 'export_reports'
  | 'view_facility_settings'
  | 'manage_facility_settings'
  /**
   * Turning subscription products on and off. A facility-admin and
   * CorporateStaff role default, so most admins hold it — facilities narrow it
   * by editing their own role. Reads need no permission.
   */
  | 'manage_subscriptions'
  | 'manage_financial_integrations'
  | 'manage_positions'
  | 'manage_requirements'
  | 'view_admins'
  | 'manage_admins'
  | 'manage_roles'
  | 'send_messages'
  | 'view_messages'
  | 'send_announcements';
